import { FC } from 'react';
import { Links } from '../SearchContext';
import AlertContent from './AlertContent';
import AlertModalWrapper from './AlertModalWrapper';

type AlertPanelProps = {
    links: Links;
};

export const AlertPanel: FC<AlertPanelProps> = ({ links }) => {
    return (
        <AlertModalWrapper>
            <AlertContent links={links} />
        </AlertModalWrapper>
    );
};
